import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"0.22rem","padding-bottom":"0"} }
const _hoisted_2 = { style: {"display":"flex","border-bottom":"1px solid #e5e6eb"} }

import {
  defineComponent,
  ref,
  onMounted,
  watchEffect,
  inject,
  provide,
  getCurrentInstance,
} from "vue";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'leftTemplate2',
  props: {
  top_tabShow: String,
},
  setup(__props) {

document.title = "标识山西-我的素材";
const router = useRouter();
//直接跳转

const leftGoto = (type) => {
  router.push(type);
};

const instance = getCurrentInstance();
const tabClick = (type) => {
  instance?.emit("tabClick", type);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["top_tab", __props.top_tabShow == 'VIDEO' ? 'top_tab_select' : '']),
        style: {"margin-left":"0"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (tabClick('VIDEO')))
      }, " 视频素材 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["top_tab", __props.top_tabShow == 'MUSIC' ? 'top_tab_select' : '']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (tabClick('MUSIC')))
      }, " 音乐素材 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["top_tab", __props.top_tabShow == 'IMAGE' ? 'top_tab_select' : '']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (tabClick('IMAGE')))
      }, " 图片素材 ", 2)
    ])
  ]))
}
}

})